export class SC_WorkorderStatus {
    public static readonly ALL = 0;
    public static readonly PENDING_BID = 1;
    public static readonly PENDING_BID_APPROVAL = 2;
    public static readonly PENDING_BID_RESUBMISSION = 3;
    public static readonly PENDING_BID_ACCEPTANCE_CONFIRMATION = 4;
    public static readonly UNSCHEDULED_OR_PCA = 5;
    public static readonly PENDING_CONFIRM = 6;
    public static readonly PENDING_FINAL_CONFIRM = 7;
    public static readonly IMMINENT = 8;
    public static readonly EMERGENCY_IMMINENT = 9;
    public static readonly IN_PROGRESS = 10;
    public static readonly IN_PROGRESS_MULTIDAY = 11;
    public static readonly EMERGENCY_LATE = 12;
    public static readonly RESCHEDULE = 13;
    public static readonly PARTIAL_MISSED = 14;
    public static readonly JOB_COMPLETE = 15;
    public static readonly READY_TO_BILL = 16;
    public static readonly INVOICED_IN_REVIEW = 17;
    public static readonly INVOICED_REJECTED = 21;
    public static readonly INVOICED_REVIEW_DELAYED = 18;
    public static readonly INVOICED_PAYMENT_PENDING = 19;
    public static readonly COMPLETED = 20;
    public static readonly FOLLOW_UP = 98;
    public static readonly CANCELLED = 99;

    public static readonly ColoredValues = [
        SC_WorkorderStatus.ALL,
        SC_WorkorderStatus.PENDING_BID,
        SC_WorkorderStatus.PENDING_BID_APPROVAL,
        SC_WorkorderStatus.PENDING_BID_ACCEPTANCE_CONFIRMATION,
        SC_WorkorderStatus.PENDING_BID_RESUBMISSION,
        SC_WorkorderStatus.UNSCHEDULED_OR_PCA,
        SC_WorkorderStatus.PENDING_CONFIRM,
        SC_WorkorderStatus.PENDING_FINAL_CONFIRM,
        SC_WorkorderStatus.IMMINENT,
        SC_WorkorderStatus.EMERGENCY_IMMINENT,
        SC_WorkorderStatus.IN_PROGRESS,
        SC_WorkorderStatus.IN_PROGRESS_MULTIDAY,
        SC_WorkorderStatus.EMERGENCY_LATE,
        SC_WorkorderStatus.RESCHEDULE,
        SC_WorkorderStatus.PARTIAL_MISSED,
        SC_WorkorderStatus.JOB_COMPLETE,
        SC_WorkorderStatus.READY_TO_BILL,
        SC_WorkorderStatus.INVOICED_IN_REVIEW,
        SC_WorkorderStatus.INVOICED_REVIEW_DELAYED,
        SC_WorkorderStatus.INVOICED_REJECTED,
        SC_WorkorderStatus.INVOICED_PAYMENT_PENDING,
        SC_WorkorderStatus.COMPLETED,
        SC_WorkorderStatus.FOLLOW_UP,
        SC_WorkorderStatus.CANCELLED
    ].map(it => {
        return new SC_WorkorderStatus(it).remap();
    });

    public readonly value: number;

    private constructor(value: number) {
        this.value = value;
    }

    static fromAPI(value: number): SC_WorkorderStatus {
        switch (Number(value)) {
            case SC_WorkorderStatus.ALL:
                return new SC_WorkorderStatus(SC_WorkorderStatus.ALL);
            case SC_WorkorderStatus.UNSCHEDULED_OR_PCA:
                return new SC_WorkorderStatus(SC_WorkorderStatus.UNSCHEDULED_OR_PCA);
            case SC_WorkorderStatus.IN_PROGRESS:
                return new SC_WorkorderStatus(SC_WorkorderStatus.IN_PROGRESS);
            case SC_WorkorderStatus.COMPLETED:
                return new SC_WorkorderStatus(SC_WorkorderStatus.COMPLETED);
            default:
                // return new SC_WorkorderStatus(SC_WorkorderStatus.ALL);
                return new SC_WorkorderStatus(Number(value));
        }
    }

    toAPI(): number {
        return this.value;
    }

    is(value: number): boolean {
        return this.value === value;
    }

    clone(): SC_WorkorderStatus {
        return new SC_WorkorderStatus(this.value);
    }

    remap(other?: number) {
        return {
            key: other ?? this.value,
            value: this.shortName,
            className: this.className,
        }
    }
    
    get className(): string {
        switch (this.value) {
            case SC_WorkorderStatus.PENDING_BID:
                return "WoPendingBid";
            case SC_WorkorderStatus.PENDING_BID_APPROVAL:
                return "WoPendingBidApproval";
            case SC_WorkorderStatus.PENDING_BID_ACCEPTANCE_CONFIRMATION:
                return "WoPendingBidAcceptanceConfirmation";
            case SC_WorkorderStatus.PENDING_BID_RESUBMISSION:
                return "WoBidRejected";
            case SC_WorkorderStatus.UNSCHEDULED_OR_PCA:
                return "WoUnscheduledPCA";
            case SC_WorkorderStatus.PENDING_CONFIRM:
                return "WoPendingConfirm";
            case SC_WorkorderStatus.PENDING_FINAL_CONFIRM:
                return "WoPendingFinalConfirm";
            case SC_WorkorderStatus.IMMINENT:
                return "WoImminent";
            case SC_WorkorderStatus.EMERGENCY_IMMINENT:
                return "WoEmergencyImminent";
            case SC_WorkorderStatus.IN_PROGRESS:
                return "WoInProgress";
            case SC_WorkorderStatus.IN_PROGRESS_MULTIDAY:
                return "WoInProgressMultiday";
            case SC_WorkorderStatus.EMERGENCY_LATE:
                return "WoEmergencyImminentLate";
            case SC_WorkorderStatus.RESCHEDULE:
                return "WoServicesReschedule";
            case SC_WorkorderStatus.PARTIAL_MISSED:
                return "WoServicesPartialMiss";
            case SC_WorkorderStatus.JOB_COMPLETE:
                return "WoServicesComplete";
            case SC_WorkorderStatus.READY_TO_BILL:
                return "WoBillable";
            case SC_WorkorderStatus.INVOICED_IN_REVIEW:
                return "WoInvoiceInReview";
            case SC_WorkorderStatus.INVOICED_REJECTED:
                return "WoInvoiceRejected";
            case SC_WorkorderStatus.INVOICED_REVIEW_DELAYED:
                return "WoInvoiceInReview";
            case SC_WorkorderStatus.INVOICED_PAYMENT_PENDING:
                return "WoInvoiceApproved";
            case SC_WorkorderStatus.COMPLETED:
                return "WoSettled";
            case SC_WorkorderStatus.FOLLOW_UP:
                return "WoFollowUp";
            case SC_WorkorderStatus.CANCELLED:
                return "WoCanceled";
        }
    }

    get shortName(): string {
        switch (this.value) {
            case SC_WorkorderStatus.ALL:
                return "All";
            case SC_WorkorderStatus.PENDING_BID:
                return "Bid";
            case SC_WorkorderStatus.PENDING_BID_APPROVAL:
                return "Bid Approval Pending";
            case SC_WorkorderStatus.PENDING_BID_ACCEPTANCE_CONFIRMATION:
                return "Bid Approved";
            case SC_WorkorderStatus.PENDING_BID_RESUBMISSION:
                return "Bid Rejected";
            case SC_WorkorderStatus.UNSCHEDULED_OR_PCA:
                return "Unscheduled & Pending Crew Assign";
            case SC_WorkorderStatus.PENDING_CONFIRM:
                return "Pending Confirm";
            case SC_WorkorderStatus.PENDING_FINAL_CONFIRM:
                return "Final Confirm";
            case SC_WorkorderStatus.IMMINENT:
                return "Schedule & Job Link Ready";
            case SC_WorkorderStatus.EMERGENCY_IMMINENT:
                return "Emergency One-Off";
            case SC_WorkorderStatus.IN_PROGRESS:
                return "In Progress";
            case SC_WorkorderStatus.IN_PROGRESS_MULTIDAY:
                return "Multi-Day In-Progress";
            case SC_WorkorderStatus.EMERGENCY_LATE:
                return "Late - Emergency One-Off";
            case SC_WorkorderStatus.RESCHEDULE:
                return "Re-Schedule Job";
            case SC_WorkorderStatus.PARTIAL_MISSED:
                return "Partial WO - Missed Job";
            case SC_WorkorderStatus.JOB_COMPLETE:
                return "Job Complete";
            case SC_WorkorderStatus.READY_TO_BILL:
                return "Compliance Complete";
            case SC_WorkorderStatus.INVOICED_IN_REVIEW:
                return "Invoice Complete";
            case SC_WorkorderStatus.INVOICED_REVIEW_DELAYED:
                return "Invoice Complete - Delayed";
            case SC_WorkorderStatus.INVOICED_REJECTED:
                return "Invoice Rejected";
            case SC_WorkorderStatus.INVOICED_PAYMENT_PENDING:
                return "Payment Approved - Waiting for Check";
            case SC_WorkorderStatus.COMPLETED:
                return "Completed";
            case SC_WorkorderStatus.CANCELLED:
                return "Canceled";
            case SC_WorkorderStatus.FOLLOW_UP:
                return "Follow Up";
        }
    }
}
